import { render } from "./InfiniteLoading.vue?vue&type=template&id=825b7b06&scoped=true"
import script from "./InfiniteLoading.vue?vue&type=script&lang=js"
export * from "./InfiniteLoading.vue?vue&type=script&lang=js"

import "./InfiniteLoading.vue?vue&type=style&index=0&id=825b7b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825b7b06"],['__file',"src/components/ui/InfiniteLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "825b7b06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('825b7b06', __exports__)) {
    api.reload('825b7b06', __exports__)
  }
  
  module.hot.accept("./InfiniteLoading.vue?vue&type=template&id=825b7b06&scoped=true", () => {
    api.rerender('825b7b06', render)
  })

}


export default __exports__